// Generated from the pinned archive member by loom.openvsp-ss-control-to-wing-control/v1.
// Source bytes are not bundled. Receipt and definition revisions are recomputed in tests.
export const OPENVSP_WING_CONTROL_CANARY_GENERATED = {
  archiveMemberPath: "models/Ur1FCPtGm8kHaqnVCi2i/cessna182.vsp3",
  definitionRevision: "sha256:92af5f0451694e2d6914e51163c7957747333dffb930595e4a13491aef932fbf",
  definition: {
    schema: "loom.wing-control-surface-collection/v1",
    wingId: "cessna-main-wing",
    wingDefinitionRevision: "sha256:6a8785c8de176d35270c92d71ddd77921a82c312148810ac0e9f7b023d749208",
    controlSurfaces: [{
      id: "vsp-BFXIRXIKXM",
      label: "SS_CONT_1",
      spanBand: { start: 0.5, end: 1 },
      hinge: {
        inboard: { xOverChord: 0.75, skinHeightFraction: 0.5 },
        outboard: { xOverChord: 0.75, skinHeightFraction: 0.5 },
      },
      noseCove: { kind: "sealed", gapRatio: 0, filletRatio: 0, endGapRatio: 0 },
      limitsDeg: {
        port: { minimum: -30, maximum: 30 },
        starboard: { minimum: -30, maximum: 30 },
      },
    }],
  },
  receipt: {
    schema: "loom.openvsp-wing-control-import/v1",
    importer: {
      id: "loom.openvsp-ss-control-to-wing-control/v1",
      revision: "sha256:c4019281b8a3ec8678f2c42b87bb8f45dab876e7daa3a2e011f623a4f4f962be",
    },
    source: {
      sha256: "sha256:a1eb29122e92e7da969ee717ba11378de9614608b1987ae5ea89a58093e7496a",
      bytes: 518_721,
      vsp3Version: "4",
      wingGeomId: "WUQJBCSHNO",
    },
    inputs: {
      selection: {
        mode: "include",
        sourceControlIds: ["BFXIRXIKXM"],
      },
      neutralWing: {
        adapterId: "loom.native-wing-authoring-to-wing-panel/v1",
        definitionRevision: "sha256:6a8785c8de176d35270c92d71ddd77921a82c312148810ac0e9f7b023d749208",
      },
      targetPanels: {
        geometryRevision: "sha256:d9a33e0ab45ac4f9dfba66f9e8b1c8e845ff71f8b1ad673e61329257c2516827",
        panelIds: ["panel-1"],
      },
    },
    parity: {
      status: "proven-xz-reflection",
      sourcePlanarSymmetryFlag: 2,
      ancestorGeomIds: ["AJQPPZNEYK", "XICZNHZQGF"],
      ancestorFramePolicy: "xz-plane-preserving-declared-transform-attach-chain/v2",
      rejectionCode: null,
    },
    target: {
      wingId: "cessna-main-wing",
      wingDefinitionRevision: "sha256:6a8785c8de176d35270c92d71ddd77921a82c312148810ac0e9f7b023d749208",
      controlDefinitionRevision: "sha256:92af5f0451694e2d6914e51163c7957747333dffb930595e4a13491aef932fbf",
      topology: "separate-fixed-and-mirrored-movable-bodies/v1",
      kinematics: "straight-3d-hinge-rigid-semantic-te-down/v1",
      hingeCompatibility: "loom-target-panels-straight-3d-hinge-resolved/v1",
    },
    mapping: {
      span: "SS_Control.UStart-UEnd-to-leading-edge-arclength-adapted/v1",
      hingeChord: "Abs_Rel_Flag-1:one-minus-Length_C_Start-End:adapted/v2",
      hingeHeight: "mid-thickness-adapted-not-source-authored/v1",
      sourceHingeFidelity: "unproven-not-source-evaluated/v1",
      noseCove: "sealed-zero-gap-loom-preview-not-openvsp-trim/v1",
      limits: "loom-import-policy-minus30-plus30-not-openvsp-source/v1",
      groupPolicy: "native-groups-reconciled-all-nonzero-coupling-rejected/v2",
    },
    claims: {
      openVspHingeExact: false,
      openVspTrimExact: false,
      openVspCoveExact: false,
      openVspBooleanExact: false,
      openVspSourceRoundTrip: false,
    },
    inventory: [
      {
        occurrenceIndex: 0,
        sourceControlId: "FVFFRUIQIZ",
        sourceName: "SS_CONT_0",
        sourceSubsurfaceType: 3,
        disposition: "rejected",
        rejectionCode: "openvsp-control-not-selected",
        targetControlSurfaceId: null,
      },
      {
        occurrenceIndex: 1,
        sourceControlId: "BFXIRXIKXM",
        sourceName: "SS_CONT_1",
        sourceSubsurfaceType: 3,
        disposition: "imported",
        rejectionCode: null,
        targetControlSurfaceId: "vsp-BFXIRXIKXM",
      },
    ],
    revision: "sha256:2d48e93f7f6a4cad3bd5be1f5903ebd8024d074d34b9a611a84161ab2c79e4db",
  },
} as const;
